export function handleDemoFormOrBot () {
  const reloadTimer = 500;
  const bookADemoButtons = document.querySelectorAll('[data-toggle=get-a-demo]');
  const resetScroll = document.getElementById('reset-scroll');
  resetScroll && resetScroll.classList.add('enterprise-page');

  bookADemoButtons.forEach(button => {
    button.addEventListener('pointerup', () => {
      const pageHasBot = !!document.getElementById('hubspot-messages-iframe-container');

      pageHasBot ? _handleBot() : _handleForm();
    });
  });
}

function _handleBot () {
  const isBotOpened = document.querySelector('.shadow-container').classList.contains('active');

  if (isBotOpened) {
    window.HubSpotConversations.widget.close();

  } else if (window.location.href.includes('?bookademo=true')) {
    window.HubSpotConversations.widget.open();

  } else {
    window.history.pushState({}, 'bookademo', '?bookademo=true');
    window.HubSpotConversations.widget.refresh({ openToNewThread: true });

    setTimeout(() => window.HubSpotConversations.widget.open(), reloadTimer);
  }
}

function _handleForm () {
  const form = document.getElementById('contact-form');

  form && form.scrollIntoView({ behavior: 'smooth' });
}
